    import React, { useRef, useState, useEffect, Fragment } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { API } from "aws-amplify";
import { getShow, getShowTickets, getChildShows, getShowMap } from '../../libs/showsLib';
import { Container, Row, Col, Button, Badge, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoneyBillAlt, faCreditCard } from "@fortawesome/free-regular-svg-icons";
import { faFileInvoice, faCheck } from "@fortawesome/free-solid-svg-icons";
import Cookie from 'js-cookie';

import Loader from 'components/Loader'
import CartTimer from "components/cart/CartTimer"

import ShowTitle from "components/shows/ShowTitle";
import ShowInfo from "components/shows/ShowInfo";
import ShowImage from "components/shows/ShowImage";
import ShowTicketBox from "components/shows/ShowTicketBox";
import ShowSocialBox from "components/shows/ShowSocialBox";
import ShowTickets from "components/shows/ShowTickets";
import ShowMapTickets from "components/shows/ShowMapTickets";
import ShowDates from "components/shows/ShowDates";
import ShowRegistration from "components/shows/ShowRegistration";
import QuickBuyForm from "components/cart/QuickBuyForm";
import RegistrationForm from "components/cart/RegistrationForm";

import { onError, Notification } from "libs/errorLib";
import { useAppContext } from "libs/contextLib";

import { getIpGeo } from 'libs/ipgeo';
import config from 'config';

import "../../../node_modules/noty/lib/noty.css";
import "../../../node_modules/noty/lib/themes/bootstrap-v4.css";
import "containers/Show.css";


export default function Show(props) {
    
  const history = useHistory(); 
  const { id } = useParams();  
  const {isAuthenticated, getSession, updateCartCounter, resetCart } = useAppContext();
  const [user, setUser] = useState(null)
  const [show, setShow] = useState(null);
  const [viewerShow, setViewerShow] = useState(null);  
  const [tickets, setTickets] = useState(null);
  const [showDates, setShowDates] = useState(null);
  const [showMap, setShowMap] = useState(null);
  const [selectedShowDate, setSelectedShowDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
    
  let session = null
  
    useEffect(() => {

    // const searchParams = new URLSearchParams(location.search);
    // if (searchParams.get('activated') == "1") {
    //     //Notification('success','Tu boleto ha sido activado exitosamente')
    //     setShowActivationModal(false)        
    // }

    async function onLoad() {
        try {           
            setIsLoading(true)
            session = await getSession()
            if (session) {
                setUser(session?.user)
            }            
            
            const show = await loadShow();
            if (show?.settings?.is_show_date) {
                history.push(`/shows/${show.parent_show_uid}`)
                return;
            }
            setShow(show)
            // console.log(show)

            if (show?.settings?.has_show_dates) {
                loadChildShows();                
            } else {
                setSelectedShowDate(show)
                //loadShowTickets(show._id)
            }
            
            if (isAuthenticated) {    
                console.log(session, show)            
                const vShow = await loadViewerShow(session.viewer._id, show._id)
            }

        } catch (e) {
            onError(e);
        } finally {
            setIsLoading(false)
        }
    }

    onLoad();
    }, [id]);

    useEffect(() => {
        async function loadShowDateTickets() {
            if (selectedShowDate) { 
                await loadShowTickets(selectedShowDate._id)
                if (selectedShowDate?.settings?.has_map) {
                    loadShowMap(selectedShowDate._id)
                }
            } else {
                setTickets(null)
            }
        }
        loadShowDateTickets();
    }, [selectedShowDate]);

    /* API CALLS  */

    async function loadShow() {
        return getShow(id);
    }
    async function loadShowTickets(show_uid, paymentType) {
        // Determine payment types based on show.paid
        const paymentTypes = show.paid 
            ? 'CREDIT_CARD|REGISTRATION|BANK_DEPOSIT|ACCOUNT_BANK_DEPOSIT'
            : 'REGISTRATION';
        
        const tickets = await getShowTickets(show_uid, paymentTypes);
        if (tickets && tickets.items && tickets.items.length > 0) {
            tickets.items.forEach(t => { t.selected = 0 })
            setTickets(tickets.items)
        }
        return tickets
    }
    async function loadViewerShow(viewer_id, show_id) {
        const vShow = await API.get("vivelo", `/viewers/viewers/${viewer_id}/shows/${show_id}`);        
        if (vShow) {
            setViewerShow(vShow)
        }
        return vShow
    }
    async function loadChildShows() {
        const children = await getChildShows(id, { filter: 'CURRENT', visible: -1 });
        const dates = children && children.items ? children.items : []
        setShowDates(dates)
    }

    async function loadShowMap(show_uid) {
        const map = await getShowMap(show_uid);
        setShowMap(map)
    }

    async function handlePaymentSuccess(purchase) {
        await updateCartCounter()
        history.push(`/orders/${purchase.id}`)
    }

    async function handleRegistrationSuccess(payment_info, purchase) {
        await updateCartCounter()
        history.push(`/shows/${show._id}/registration/success/${purchase.id}`)
    }


    // if (activated == "1") {
    //     Notification('success', "Tu boleto fue activado exitosamente")
    // }
    // <LinkContainer key={`name-${show.id}`} to={`/shows/${show.id}/play`} target="_blank" style={{marginLeft: 'auto', fontSize: '1.8rem', marginLeft:'auto'}} >

    function onShowDateChange(show_id) {
        const selected = showDates.find(s => s._id == show_id)
        setSelectedShowDate(selected)
    }

    function resetTicketSelection() {
        if (tickets) {
        setTickets(tickets.map(t => {
                t.selected = 0
                return t
            }))
        }
    }

    /**
     * Filters tickets based on payment types
     * @param {Array<{payment_type: string[]}>} tickets - Array of tickets to filter
     * @param {string[]} paymentTypes - Array of payment types to match against
     * @returns {Array<{payment_type: string[]}>} Filtered array of tickets
     */
    function filteredTickets(tickets, paymentTypes = []) {
        if (!tickets || !paymentTypes || paymentTypes.length === 0) {
            return tickets;
        }
        
        return tickets.filter(ticket => 
            ticket.payment_type && 
            Array.isArray(ticket.payment_type) && 
            ticket.payment_type.some(type => paymentTypes.includes(type))
        );
    }

    /**
     * Determines available payment methods based on show settings
     * @returns {Array<string>} Array of available payment method keys
     */
    function getAvailablePaymentMethods() {
      const methods = [];
      
      // Check for deposit/transfer option
      if (show.settings.deposit && show.settings.quickbuy_link) {
        methods.push('deposit');
      }
      
      // Check for credit card option
      if (!show.settings.deposit_only) {
        methods.push('card');
      }
      
      return methods;
    }

    /**
     * Auto-selects payment method when only one is available
     */
    useEffect(() => {
      if (show && !selectedMethod) {
        const availableMethods = getAvailablePaymentMethods();
        
        // Auto-select if only one payment method is available
        if (availableMethods.length === 1) {
          const method = availableMethods[0];
          console.log(`Auto-selecting payment method: ${method}`);
          handleSelectMethod(method);
        }
      }
    }, [show, selectedMethod]);

    function handleSelectMethod(method) {
        if (selectedMethod != method) {
            if (show.settings.has_show_dates) {
                setSelectedShowDate(null)
            }
            resetTicketSelection()
        }
        setSelectedMethod(method);
        // if (method === 'deposit') {
        //     // if (show.settings.quickbuy_link) {
        //     //     window.open(show.settings.quickbuy_link, '_blank');
        //     // }
            
        // } else {
        //     setSelectedMethod(method);
        // }
    }

    function renderQuickBuyLink() {
        return <div class="quickbuy_link">
            <a href={show.settings.quickbuy_link} target="_blank">                
                <FontAwesomeIcon icon={faMoneyBillAlt} />
                <span>Registra aquí tu pago con depósito o transferencia bancaria<br />{show.settings.quickbuy_link}</span>                
            </a>
        </div>
    }

    function onDepositSuccess(payment_info, purchase) {
        history.push(`/shows/${show._id}/quicklink/success/${purchase.id}`)
    }

    return (
        !isLoading && show ? (
            <div className="Show show-main-vertical content-dark">
                <CartTimer />
                <div className="show-main-content">
                    <ShowImage show={show} viewerShow={viewerShow} />
                    <ShowTitle show={show} />
                    <ShowInfo show={show} type="boxes" />
                    <ShowInfo show={show} type="about" />
                    <ShowInfo show={show} type="important" tickets={tickets} />
                    
                    {/* Registration Flow for Free Shows */}
                    {!show.paid && (
                        <div className="show-registration-section">
                            <div className="section-title"><span className="section-title__accent" />Regístrate</div>
                            <RegistrationForm 
                                user={user} 
                                sessionId={Cookie.get('sessionID')} 
                                show={show} 
                                tickets={filteredTickets(tickets, ['REGISTRATION'])} 
                                showDates={showDates} 
                                showMap={showMap} 
                                onShowDateChange={onShowDateChange} 
                                selectedShowDate={selectedShowDate}
                                isLoadingData={isLoading}
                                onSuccess={handleRegistrationSuccess}
                            />
                        </div>
                    )}
                    
                    {/* Payment Methods Row and Ticket Selection for Paid Shows */}
                    {show.paid && (
                        <div className="show-payment-section">
                            <div className="section-title"><span className="section-title__accent" />Comprar</div>

                            {/* Payment Methods Row - Only show if multiple methods available */}
                            {getAvailablePaymentMethods().length > 1 && (
                                <div className="payment-methods-row">
                                    {show.settings.deposit && (
                                        <div
                                            className={`payment-method-card${selectedMethod === 'deposit' ? ' payment-method-card--selected' : ''}`}
                                            onClick={() => handleSelectMethod('deposit')}
                                            tabIndex={0}
                                            role="button"
                                        >
                                            <div className="payment-method-card__header">
                                                <div className="payment-method-card__icon">
                                                    <FontAwesomeIcon icon={faFileInvoice} />
                                                </div>
                                                <div className="payment-method-card__title-group">
                                                    <div className="payment-method-card__title">Depósito o transferencia</div>
                                                    <div className="payment-method-card__subtitle">Pago tradicional bancario</div>
                                                </div>
                                                <div className="payment-method-card__check">
                                                    {selectedMethod === 'deposit' && (
                                                        <div className="payment-method-card__check-circle">
                                                            <FontAwesomeIcon icon={faCheck} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="payment-method-card__footer">
                                                <div className="payment-method-card__extra">
                                                    Realiza tu pago y registra la transacción en nuestro formulario
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {!show.settings.deposit_only && (
                                        <div
                                            className={`payment-method-card${selectedMethod === 'card' ? ' payment-method-card--selected' : ''}`}
                                            onClick={() => handleSelectMethod('card')}
                                            tabIndex={0}
                                            role="button"
                                        >
                                            <div className="payment-method-card__header">
                                                <div className="payment-method-card__icon">
                                                    <FontAwesomeIcon icon={faCreditCard} />
                                                </div>
                                                <div className="payment-method-card__title-group">
                                                    <div className="payment-method-card__title">Tarjeta de crédito/débito</div>
                                                    <div className="payment-method-card__subtitle">Pago inmediato y seguro</div>
                                                </div>
                                                <div className="payment-method-card__check">
                                                    {selectedMethod === 'card' && (
                                                        <div className="payment-method-card__check-circle">
                                                            <FontAwesomeIcon icon={faCheck} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="payment-method-card__footer">
                                                <div className="payment-method-card__extra">
                                                    Visa, Mastercard, American Express aceptadas
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Show selected payment method content */}
                            {selectedMethod && (
                                <div>
                                    <div className="payment-method-card__content">
                                        {selectedMethod === 'deposit' && (
                                            <div className="payment-method-card__selected-content">
                                                <QuickBuyForm 
                                                    user={user} 
                                                    sessionId={Cookie.get('sessionID')} 
                                                    show={show} 
                                                    tickets={filteredTickets(tickets, ['BANK_DEPOSIT', 'ACCOUNT_BANK_DEPOSIT'])} 
                                                    showDates={showDates} 
                                                    showMap={showMap} 
                                                    onShowDateChange={onShowDateChange} 
                                                    selectedShowDate={selectedShowDate}
                                                    bankDepositInfo={selectedShowDate?.settings?.deposit_info}
                                                    isLoadingData={isLoading}
                                                    onSuccess={onDepositSuccess}
                                                    showHeaderVisible={false}
                                                />
                                            </div>
                                        )}
                                        {selectedMethod === 'card' && (
                                            <div className="payment-method-card__selected-content">                                            
                                                <ShowDates show={show} showDates={showDates} onChange={onShowDateChange} />
                                                {selectedShowDate && (
                                                    show.settings?.registration ? (
                                                        <ShowRegistration show={selectedShowDate} tickets={filteredTickets(tickets, ['REGISTRATION'])} onSuccess={handlePaymentSuccess} />
                                                    ) : (
                                                        selectedShowDate.settings.has_map ?
                                                            showMap ? <ShowMapTickets show={selectedShowDate} showTickets={filteredTickets(tickets, ['CREDIT_CARD'])} showMap={showMap}  /> : <Loader />                                         
                                                            : <ShowTickets show={selectedShowDate} tickets={filteredTickets(tickets, ['CREDIT_CARD'])} paymentType="CREDIT_CARD" />                                                    
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        ) : <Loader />
  );
}